import { render } from "./StudentCoretimeDataTable.vue?vue&type=template&id=19be2c98&scoped=true"
import script from "./StudentCoretimeDataTable.vue?vue&type=script&lang=js"
export * from "./StudentCoretimeDataTable.vue?vue&type=script&lang=js"

import "./StudentCoretimeDataTable.vue?vue&type=style&index=0&id=19be2c98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19be2c98"]])

export default __exports__